export default __webpack_public_path__ + "static/media/moreAccessoriesInactive.8c59d891.svg";